import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import {
  CmsConfig,
  I18nModule,
  provideDefaultConfig,
  UrlModule,
} from '@spartacus/core'
import { IconModule, MediaModule } from '@spartacus/storefront'
import { MiniCartComponent } from './mini-cart.component'
import { MiniCartDetailsComponent } from './mini-cart-detail/mini-cart-details/mini-cart-details.component'
import { MiniCartDetailModule } from './mini-cart-detail/mini-cart-detail.module'
import { ClickOutsideModule } from '../../../shared/directive/clickOutside/click-outside.module';
import { MiniQuoteCartDetailsComponent } from './mini-quote-cart-details/mini-quote-cart-details.component'
import { quoteReducer } from './store/mini-quote-cart.reducer';
import { QuoteCartEffects } from './store/mini-quote-cart.effects';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    UrlModule,
    IconModule,
    I18nModule,
    MiniCartDetailModule,
    ClickOutsideModule,
    MediaModule,
    StoreModule.forFeature('quoteCart', quoteReducer),
    EffectsModule.forFeature([QuoteCartEffects]),
  ],
  providers: [
    provideDefaultConfig({
      cmsComponents: {
        MiniCartComponent: {
          component: MiniCartComponent,
        },
      },
    } as CmsConfig),
  ],
  declarations: [MiniCartComponent, MiniCartDetailsComponent, MiniQuoteCartDetailsComponent],
  exports: [MiniCartComponent, MiniCartDetailsComponent],
})
export class MiniCartModule {}
